import { jsx as _jsx } from "react/jsx-runtime";
import { useIntl } from 'react-intl';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { BriefcaseIcon, IndustryIcon, UserFaIcon } from '../../Icons';
import { MultiSelectButtons } from '../MultiSelectButtons';
export const FilterRelationTypeButtons = ({ item, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => {
    const { formatMessage } = useIntl();
    return {
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(MultiSelectButtons, { options: [
                {
                    id: '0',
                    label: formatMessage(listItemMsg('relationType', 0, 'Company')),
                    icon: _jsx(IndustryIcon, {}),
                },
                {
                    id: '1',
                    label: formatMessage(listItemMsg('relationType', 1, 'Sole proprietor')),
                    icon: _jsx(BriefcaseIcon, {}),
                },
                {
                    id: '2',
                    label: formatMessage(listItemMsg('relationType', 2, 'Person')),
                    icon: _jsx(UserFaIcon, {}),
                },
            ], onChange: value => {
                var _a;
                return setFilter({
                    [item]: ((_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0) > 0 ? value : undefined,
                });
            }, selected: activeFilters[item], fullWith: true })),
    };
};
